import { ICellRendererParams } from "ag-grid-community";
import { Stack, Typography } from "@mui/joy";
import { AgentObj } from "@/types/interfaces/agents";

export const OptionalValueCellRenderer = ({ value }: ICellRendererParams<AgentObj>) => (
  <Stack direction="row" alignItems="center" gap={1}>
    <Typography level="body-sm" component={"span"} noWrap>
      {value ? value : "-"}
    </Typography>
  </Stack>
);
